import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  Timestamp,
} from "firebase/firestore";
import { projectData } from "./Constants";

const RESERVATIONS_COLLECTION = projectData().RESERVATIONS_COLLECTION;

// Add a new reservation
export const addReservation = async (reservationData) => {
  try {
    // Add timestamp for creation
    const dataWithTimestamp = {
      ...reservationData,
      createdAt: Timestamp.now(),
      status: "pending",
    };

    const docRef = await addDoc(
      collection(db, RESERVATIONS_COLLECTION),
      dataWithTimestamp
    );
    return { id: docRef.id, ...dataWithTimestamp };
  } catch (error) {
    console.error("Error adding reservation: ", error);
    throw error;
  }
};

// Get all reservations
export const getReservations = async () => {
  try {
    const q = query(
      collection(db, RESERVATIONS_COLLECTION),
      orderBy("createdAt", "desc")
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error getting reservations: ", error);
    throw error;
  }
};

// Update reservation status
export const updateReservationStatus = async (id, status) => {
  try {
    const reservationRef = doc(db, RESERVATIONS_COLLECTION, id);
    await updateDoc(reservationRef, {
      status,
      updatedAt: Timestamp.now(),
    });
    return true;
  } catch (error) {
    console.error("Error updating reservation: ", error);
    throw error;
  }
};

// Delete reservation
export const deleteReservation = async (id) => {
  try {
    await deleteDoc(doc(db, RESERVATIONS_COLLECTION, id));
    return true;
  } catch (error) {
    console.error("Error deleting reservation: ", error);
    throw error;
  }
};

// Get reservations by status
export const getReservationsByStatus = async (status) => {
  try {
    const q = query(
      collection(db, RESERVATIONS_COLLECTION),
      where("status", "==", status),
      orderBy("createdAt", "desc")
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error(`Error getting ${status} reservations:`, error);
    throw error;
  }
};

// Diabetes Care functions
export const getDiabetesCareRegistrations = async () => {
  try {
    const q = query(collection(db, "siwaDM"), orderBy("registeredAt", "desc"));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error getting diabetes care registrations: ", error);
    throw error;
  }
};

// Update diabetes care registration status
export const updateDiabetesCareStatus = async (id, status) => {
  try {
    const registrationRef = doc(db, "siwaDM", id);
    await updateDoc(registrationRef, {
      status,
      updatedAt: Timestamp.now(),
    });
    return true;
  } catch (error) {
    console.error("Error updating diabetes care registration: ", error);
    throw error;
  }
};

// Delete diabetes care registration
export const deleteDiabetesCareRegistration = async (id) => {
  try {
    await deleteDoc(doc(db, "siwaDM", id));
    return true;
  } catch (error) {
    console.error("Error deleting diabetes care registration: ", error);
    throw error;
  }
};
